import { COLOR_TOKENS } from 'base/ui/tokens';
import {
  BlocksService,
  DEFAULT_FEATURE_FLAGS,
  ListProjectsResponse,
} from './blocks_service';

const FAKE_PROJECTS: ListProjectsResponse['projects'] = [
  {
    token: 'project1',
    ownershipType: 'user',
    team: { name: 'Sample Team', color: COLOR_TOKENS.colorOrange },
    name: 'Project 1 (Personal)',
    updatedAt: 1629782400,
    currentUserLastViewedAt: 1629782400,
    createdByCurrentUser: true,
    sessions: [],
    locked: false,
  },
  {
    token: 'project2',
    ownershipType: 'team',
    team: { name: 'Sample Team', color: COLOR_TOKENS.colorOrange },
    name: 'Project 2 (Team)',
    updatedAt: 1629782400,
    currentUserLastViewedAt: 1629782400,
    createdByCurrentUser: true,
    sessions: [],
    locked: false,
  },
  {
    token: 'project3',
    ownershipType: 'user',
    team: null,
    name: undefined,
    updatedAt: 1629782400,
    currentUserLastViewedAt: 1629782400,
    createdByCurrentUser: true,
    sessions: [],
    locked: false,
  },
];

export const fakeBlocksService = {
  listProjectNames: async () => ({
    projects: FAKE_PROJECTS,
    projectsQuota: { used: 3, total: 10 },
    flags: DEFAULT_FEATURE_FLAGS,
  }),
} satisfies Partial<BlocksService>;
